import React from 'react';
import PropTypes from 'prop-types';
import utils from 'helpers/utils';

const CustomerNameField = (props) => {
    const { record, source } = props;

    function showFullName(obj) {
        const {
            first_name,
            last_name,
        } = obj;

        return (
            <span style={ { color: 'rgba(0,0,0,0.87)' } }>
                { utils.fullName(first_name, last_name) }
            </span>
        );
    }

    if (utils.isEmpty(record) && utils.isEmpty(record[source])) {
        return null;
    }

    return (
        <span>{ showFullName(record[source]) }</span>
    );
};

CustomerNameField.propTypes = {
    record: PropTypes.shape({
        first_name: PropTypes.string,
        last_name: PropTypes.string,
    }),
    source: PropTypes.string.isRequired,
};

export default CustomerNameField;



// WEBPACK FOOTER //
// ./src/components/field/CustomerNameField.js